import { NodeViewWrapper, NodeViewProps } from "@tiptap/react";
import { IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import React, { useState } from "react";

const ImageWithDownload: React.FC<NodeViewProps> = ({ node }) => {
  const [hovered, setHovered] = useState(false);
  const { src, alt, title } = node.attrs;

  const handleDownload = async (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    // Derive clean filename: strip UUID prefix from the URL path
    // URL pattern: https://domain/{article_id}/{uuid}-{clean-name}.jpg
    const urlPath = new URL(src).pathname;
    const fullFilename = urlPath.split("/").pop() || "image.jpg";
    // UUID format: 8-4-4-4-12 hex chars + trailing hyphen
    const cleanFilename = fullFilename.replace(
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/,
      ""
    );

    try {
      const response = await fetch(src);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = cleanFilename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch {
      // Fallback: open in new tab if fetch fails (e.g., CORS)
      window.open(src, "_blank");
    }
  };

  return (
    <NodeViewWrapper
      as="span"
      style={{ display: "inline-block", position: "relative" }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <img
        src={src}
        alt={alt || ""}
        title={title || ""}
        className="w-full h-auto mx-auto my-auto"
        style={{
          maxWidth: "800px",
          height: "auto",
          margin: "0 auto",
          display: "block",
        }}
      />
      {alt && (
        <span
          style={{
            display: "block",
            textAlign: "center",
            fontSize: "12px",
            color: "#666",
            marginTop: "4px",
            fontStyle: "italic",
          }}
        >
          {alt}
        </span>
      )}
      {hovered && (
        <IconButton
          onClick={handleDownload}
          size="small"
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            backgroundColor: "rgba(0,0,0,0.6)",
            color: "#fff",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
          }}
        >
          <DownloadIcon fontSize="small" />
        </IconButton>
      )}
    </NodeViewWrapper>
  );
};

export default ImageWithDownload;
